import { Card, Tabs } from "@shopify/polaris";
import { useCallback,useState } from "react";
import { AmazonForm } from "./AmazonForm";
import { FacebookForm } from "./FacebookForm";
import { GoogleForm } from "./GoogleForm";
import { LinkedinForm } from "./LinkedinForm";
import { TwitterForm } from "./TwitterForm";

export function TabsComponent() {
    const [selected, setSelected] = useState(0);
  
    const handleTabChange = useCallback(
      (selectedTabIndex) => setSelected(selectedTabIndex),
      [],
    );

    console.log(selected)
  
    const tabs = [
      {
        id: '1',
        content: 'Google',
      },
      {
        id: '2',
        content: 'Facebook',
      },
      {
        id: '3',
        content: 'Twitter',
      },
      {
        id: '4',
        content: 'Linkedin',
      },
      {
        id: '5',
        content: 'Amazon',
      },
  
    ];
  
    return (
      <Card>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
          <Card.Section >
            {selected === 0 ? <GoogleForm/>:
            selected === 1 ? <FacebookForm/>:
            selected === 2 ?<TwitterForm/>:
            selected === 3 ?<LinkedinForm/>:
            <AmazonForm/>}
          </Card.Section>
        </Tabs>
      </Card>
    );
  }

  export default TabsComponent;